export const DIRECT_SALES_UTMS = {
  mainPage: {
    utmSource: 'Formularz Strona główna',
  },
  solutionsPage: {
    utmSource: 'Formularz Strona Rozwiązania',
  },
  wellbeingPage: {
    utmSource: 'Formularz Strona Wellbeing',
  },
  conferencePage: {
    utmSource: 'Formularz Strona Konferencyjna',
  },
  products: {
    myBenefitPage: {
      utmSource: 'Formularz Strona Produktu MyBenefit',
    },
    multilifePage: {
      utmSource: 'Formularz Strona Produktu Multilife',
    },
    multisportPage: {
      utmSource: 'Formularz Strona Produktu Multisport',
    },
    wellbeingSalePage: {
      utmSource: 'Formularz Strona Produktu Wellbeing-Score',
    },
  },
}
